// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qco-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.qco-main-grid-item {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.qco-label-row {
    display: flex;
    align-items: center;
    gap: 6px;
    padding-bottom: 6px;
}

.qco-label-icon {
    font-size: 1.1vw !important;
    color: #111;
}

.qco-select-header {
    font-family: 'Poppins';
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: -0.41px;
}

.qco-optional {
    font-family: 'Poppins';
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    line-height: 22px;
    letter-spacing: -0.41px;
    color: #777;
}


.qco-search-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.qco-search-icon {
    position: absolute;
    left: 10px;
    font-size: 14px;
    color: #aaa;
    pointer-events: none;
}

.qco-search-input {
    width: 100%;
    height: 42px;
    border: 1.5px solid #e0e0e0;
    border-radius: 8px;
    padding: 0 36px 0 32px;
    font-family: 'Poppins';
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    line-height: 22px;
    letter-spacing: -0.41px;
    color: #333;
    background: #ffffff;
    outline: none;
    box-sizing: border-box;
}

.qco-search-input::placeholder {
    font-family: 'Poppins';
    font-weight: 400;
    font-size: 13px;
    color: #aaa;
}

.qco-search-input:focus {
    border-color: #888;
}

.qco-input-arrow {
    position: absolute;
    right: 12px;
    font-size: 18px;
    color: #888;
    pointer-events: none;
}

/* Text input (Purchase Order No, Stamp Instruction) */
.qco-input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.qco-text-input {
    width: 100%;
    height: 42px;
    border: 1.5px solid #e0e0e0;
    border-radius: 8px;
    padding: 0 36px 0 12px;
    font-family: 'Poppins';
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    line-height: 22px;
    letter-spacing: -0.41px;
    color: #333;
    background: #ffffff;
    outline: none;
    box-sizing: border-box;
}

.qco-text-input::placeholder {
    font-family: 'Poppins';
    font-weight: 400;
    font-size: 13px;
    color: #aaa;
}

.qco-text-input:focus {
    border-color: #888;
}

.qco-textarea {
    width: 100%;
    margin-top: 8px;
    border: 1.5px solid #e0e0e0;
    border-radius: 8px;
    padding: 10px 12px;
    font-family: 'Poppins';
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    line-height: 22px;
    letter-spacing: -0.41px;
    color: #333;
    background: #f9f9f9;
    outline: none;
    resize: none;
    box-sizing: border-box;
}

.qco-textarea::placeholder {
    font-family: 'Poppins';
    font-weight: 400;
    font-size: 13px;
    color: #aaa;
}

.qco-textarea:focus {
    border-color: #888;
    background: #fff;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/CreateModal/quickcustomerorder.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,WAAW;AACf;;;AAGA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,WAAW;IACX,oBAAoB;AACxB;;AAEA,sDAAsD;AACtD;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".qco-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.qco-main-grid-item {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.qco-label-row {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding-bottom: 6px;\n}\n\n.qco-label-icon {\n    font-size: 1.1vw !important;\n    color: #111;\n}\n\n.qco-select-header {\n    font-family: 'Poppins';\n    font-weight: 500;\n    font-style: normal;\n    font-size: 14px;\n    line-height: 22px;\n    letter-spacing: -0.41px;\n}\n\n.qco-optional {\n    font-family: 'Poppins';\n    font-weight: 400;\n    font-style: normal;\n    font-size: 13px;\n    line-height: 22px;\n    letter-spacing: -0.41px;\n    color: #777;\n}\n\n\n.qco-search-wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.qco-search-icon {\n    position: absolute;\n    left: 10px;\n    font-size: 14px;\n    color: #aaa;\n    pointer-events: none;\n}\n\n.qco-search-input {\n    width: 100%;\n    height: 42px;\n    border: 1.5px solid #e0e0e0;\n    border-radius: 8px;\n    padding: 0 36px 0 32px;\n    font-family: 'Poppins';\n    font-weight: 400;\n    font-style: normal;\n    font-size: 13px;\n    line-height: 22px;\n    letter-spacing: -0.41px;\n    color: #333;\n    background: #ffffff;\n    outline: none;\n    box-sizing: border-box;\n}\n\n.qco-search-input::placeholder {\n    font-family: 'Poppins';\n    font-weight: 400;\n    font-size: 13px;\n    color: #aaa;\n}\n\n.qco-search-input:focus {\n    border-color: #888;\n}\n\n.qco-input-arrow {\n    position: absolute;\n    right: 12px;\n    font-size: 18px;\n    color: #888;\n    pointer-events: none;\n}\n\n/* Text input (Purchase Order No, Stamp Instruction) */\n.qco-input-wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.qco-text-input {\n    width: 100%;\n    height: 42px;\n    border: 1.5px solid #e0e0e0;\n    border-radius: 8px;\n    padding: 0 36px 0 12px;\n    font-family: 'Poppins';\n    font-weight: 400;\n    font-style: normal;\n    font-size: 13px;\n    line-height: 22px;\n    letter-spacing: -0.41px;\n    color: #333;\n    background: #ffffff;\n    outline: none;\n    box-sizing: border-box;\n}\n\n.qco-text-input::placeholder {\n    font-family: 'Poppins';\n    font-weight: 400;\n    font-size: 13px;\n    color: #aaa;\n}\n\n.qco-text-input:focus {\n    border-color: #888;\n}\n\n.qco-textarea {\n    width: 100%;\n    margin-top: 8px;\n    border: 1.5px solid #e0e0e0;\n    border-radius: 8px;\n    padding: 10px 12px;\n    font-family: 'Poppins';\n    font-weight: 400;\n    font-style: normal;\n    font-size: 13px;\n    line-height: 22px;\n    letter-spacing: -0.41px;\n    color: #333;\n    background: #f9f9f9;\n    outline: none;\n    resize: none;\n    box-sizing: border-box;\n}\n\n.qco-textarea::placeholder {\n    font-family: 'Poppins';\n    font-weight: 400;\n    font-size: 13px;\n    color: #aaa;\n}\n\n.qco-textarea:focus {\n    border-color: #888;\n    background: #fff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
